import { render, staticRenderFns } from "./EventCommon.vue?vue&type=template&id=10263adb&"
import script from "./EventCommon.vue?vue&type=script&lang=js&"
export * from "./EventCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports